import { useTranslation } from 'react-i18next'
import MingcuteLockFill from '~icons/mingcute/lock-fill'

export function ArtworkPrivateLabel() {
  const { t } = useTranslation(['artwork'])

  return (
    <span className="absolute bottom-2 left-2 whitespace-nowrap inline-flex items-center gap-0.5 h-5 px-1.5 text-black bg-white ring-1 ring-black/20 rounded-full">
      <MingcuteLockFill className="flex-none size-4" />
      <span className="text-xs font-medium uppercase text-shadow-none">
        {t('artwork:generation.is-private')}
      </span>
    </span>
  )
}
